import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DashBoardService {

    private event = new Subject<any>();
    
    gravarVideo(data: any) {
        var element={
          "tipo":"gravarvideo",
          "item":data
        };
        this.event.next(element);
    }

    excluirVideo(data: any) {
      var element={
        "tipo":"excluirvideo",
        "item":data
      };
      this.event.next(element);
  }

    getObservable(): Subject<any> {
      
      if (this.event){
        return this.event;
      }
      
    }
}


